import {SpanIcon} from '@mazraeapp/react_icon_kit';

import {useNavigate} from 'react-router-dom';
import Modal from '../../../../../components/mazraeKit/modal';

interface ISuccessRegisterModalProps {
  isSuccessModal: boolean;
  setIsSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const SuccessStoryModal = ({
  setIsSuccessModal,
  isSuccessModal,
}: ISuccessRegisterModalProps) => {
  const navigate = useNavigate();

  return (
    <Modal isOpen={isSuccessModal} setIsOpen={setIsSuccessModal}>
      <div className="w-[320px] flex flex-col p-3 gap-3">
        <div className="flex items-center justify-between">
          <div className="flex w-[90%] justify-center">
            <SpanIcon className="icon-nameCheck-circle text-xxl  text-farm-shop-500" />
          </div>
          <button
            onClick={() => {
              setIsSuccessModal(false);
              navigate('/my-store-info');
            }}
          >
            <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
          </button>
        </div>
        <h5 className="w-full text-gray-950 flex justify-center">
          اطلاعات استوری شما ثبت شد
        </h5>
        <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
          پس از بررسی کارشناسان، منتشر خواهد شد.
        </p>
        {
          <button
            className="bg-farm-shop-500 text-white rounded h-10 w-full mt-1 text-regular text-sm"
            onClick={() => navigate('/my-store-info')}
          >
            متوجه شدم
          </button>
        }
      </div>
    </Modal>
  );
};

export default SuccessStoryModal;
